import { AudioManager } from '.';
import { EventsManager } from '@game-libs/events-manager';
import { GameEvents, PlayerEvents, MenuEvents } from '@game-libs/models';

export const configureSFXEvents = (play: AudioManager['playSFX']) => {
  const { on } = EventsManager();

  const AllSFXEvents = [
    ...Object.values(GameEvents),
    ...Object.values(PlayerEvents),
    ...Object.values(MenuEvents),
  ];

  AllSFXEvents.map((sfxEvent) => {
    on(sfxEvent, () => {
      play(sfxEvent);
    });
  });
};
